<style lang="scss" scoped>
.file-tab {
  min-height: 600px;

  .over {
    background-color: red;
  }
}
</style>

<template>
  <div class="file-tab">
    <v-row>
      <v-col cols="12">
        <input
          type="file"
          ref="file"
          @change="handleUploadFiles"
          v-show="false"
          accept="application/pdf, image/png, image/jpeg, text/*, .docx, .pptx, .xlsx, .msg"
          multiple
        />
        <drop
          @drop="handleDrop"
          @dragover="realTimeOver = true"
          @dragleave="realTimeOver = false"
        >
          <div>
            <v-card outlined>
              <v-overlay absolute :value="over" color="primary">
                <div class="text-h4">
                  <v-icon large left>mdi-paperclip</v-icon>
                  {{ __("anexar documentos") }}
                </div>
              </v-overlay>
              <v-card-title>
                {{ __("gestão documental") }}
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="research"
                      :label="__('buscar')"
                      single-line
                      outlined
                      dense
                      hide-details
                      clearable
                      @keyup.enter="refreshAttachments"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn
                      @click="refreshAttachments"
                      icon
                      :loading="loading_files"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn
                      @click="handleClickGenerateForms()"
                      color="primary"
                      outlined
                      class="mr-1"
                    >
                      {{ __("gerar formulários") }}
                    </v-btn>
                    <v-btn
                      @click="openFilesDialog"
                      :disabled="uploading"
                      color="primary"
                      data-test="btn-new-attachment"
                    >
                      <v-icon size="24" left>mdi-plus</v-icon
                      >{{ __("novo anexo") }}
                      <span v-if="uploadCount > 0">({{ uploadCount }})</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-tabs v-model="groupTab">
                <v-tab :value="0">{{ __("em lista") }}</v-tab>
                <v-tab :value="1">{{ __("por categorias") }}</v-tab>
                <v-tab v-if="propertyRegistryEnabled" :value="2">
                  {{ __("Caderneta predial") }}
                </v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <v-sheet>
                <v-row class="ml-2 py-2">
                  <v-col v-if="selectedFiles.length" cols="3">
                    <span class="grey--text">
                      {{ selectedFiles.length }}
                      {{
                        selectedFiles.length == 1
                          ? __("arquivo")
                          : __("arquivos")
                      }}
                    </span>
                    <v-btn @click="selectedFiles = []" icon small>
                      <v-icon small>mdi-close-circle</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col class="text-right">
                    <AttachmentMultipleVisibilityButton
                      @change_visibility="
                        handleChangeInsurerVisibilityMultipleFiles
                      "
                      :label="__('companhia')"
                      icon="mdi-domain"
                      color="cyan"
                      text
                      small
                      :disabled="selectedFiles.length < 1"
                    />
                    <AttachmentMultipleVisibilityButton
                      @change_visibility="
                        handleChangeUnityVisibilityMultipleFiles
                      "
                      :label="__('unidade')"
                      icon="mdi-account-hard-hat"
                      color="indigo"
                      text
                      small
                      :disabled="selectedFiles.length < 1"
                    />
                    <v-btn
                      @click="handleCategorizeFiles"
                      class="mr-2"
                      color="info"
                      text
                      small
                      :disabled="selectedFiles.length < 1"
                    >
                      <v-icon left>mdi-folder-edit</v-icon>
                      {{ __("categorizar") }}
                    </v-btn>
                    <v-btn
                      @click="handleDestroyMultipleFiles"
                      :loading="deleting"
                      class="mr-2"
                      color="red"
                      text
                      small
                      :disabled="selectedFiles.length < 1"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      {{ __("excluir") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-sheet>
              <div v-if="groupTab !== 2">
                <attachments-table
                  ref="attachmentsTableRef"
                  :attachments="files"
                  :categories="folders"
                  :categoryFilter.sync="categoryFilter"
                  @click:category="handleClickCategory"
                  v-model="selectedFiles"
                  :group="group"
                  :loading="loading_files"
                  @update:attachments="files = $event"
                  @update:loading="loading_files = $event"
                  :viewMode="groupTab === 0 ? 'list' : 'categories'"
                  :research="research"
                />
              </div>
              <property-registry-tab
                v-else
                :lead="lead"
                @open-document="handleOpenPropertyRegistryDocument"
              />
              <file-dialog
                v-model="file_preview"
                :attachment="file"
                @updateFile="updateFile"
                @deleteFile="deleteFile"
                @refreshAttachments="refreshAttachments"
              />
            </v-card>
          </div>
        </drop>

        <v-dialog
          v-model="sendToErrorDialog"
          :max-width="!$vuetify.breakpoint.xs ? '600px' : undefined"
        >
          <v-card>
            <v-app-bar flat>
              <v-toolbar-title>{{
                __("arquivos não permitidos")
              }}</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="sendToErrorDialog = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-app-bar>
            <v-list>
              <span
                v-for="(message, index) in sendToErrorMessages"
                :key="'messages-' + index"
              >
                <v-subheader>
                  <span style="max-width: 300px" class="text-wrap">
                    {{ message.text }}
                  </span>
                </v-subheader>
                <v-list-item
                  v-for="file in message.files"
                  :key="'messages-file' + file.id"
                >
                  <v-list-item-icon>
                    <v-icon color="red">mdi-circle-medium</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ file.name }}.{{ file.extension }}</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      file.category
                        ? file.category.description
                        : __("sem categorias")
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </span>
            </v-list>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <FormFillerDialog
      ref="form_filler"
      :lead_number="$route.params['lead_number']"
      :subtype_id="lead.subtype_id"
    />
  </div>
</template>

<script>
import i18n from "@/mixins/i18n";
import AttachmentsTable from "@/components/Lead/AttachmentsTable";
import { store, multipleDestroy } from "@/services/attachment";
import { Drop } from "vue-drag-drop";
import FormFillerDialog from "../FormFiller/FormFillerDialog.vue";
import { changeManyAttachmentsVisibility } from "@/services/attachment";
import AttachmentMultipleVisibilityButton from "@/components/Attachment/AttachmentMultipleVisibilityButton.vue";
import PropertyRegistryTab from "@/components/Lead/PropertyRegistries/PropertyRegistryTab.vue";
import FileDialog from "../FileDialog.vue";
import FeatureFlagsMixin from "@/mixins/FeatureFlagsMixin.vue";

export default {
  name: "files-tab",
  mixins: [i18n, FeatureFlagsMixin],
  components: {
    AttachmentsTable,
    Drop,
    FormFillerDialog,
    AttachmentMultipleVisibilityButton,
    PropertyRegistryTab,
    FileDialog,
  },
  data: () => ({
    i18n_prefix: "documents",
    folders: [],
    files: [],
    file_preview: false,
    file: {},
    loading_files: false,
    categoryLoading: false,
    search: "",
    categoryFilter: [],
    selectedFiles: [],
    uploadCount: 0,
    deleting: false,
    uploading: false,
    updating_visibility_insurer: false,
    updating_visibility_unity: false,
    groupTab: 0,
    over: false,
    realTimeOver: false,
    sendToErrorDialog: false,
    sendToErrorMessages: [],
    loading_files: false,
    research: "",
    propertyRegistryEnabled: false,
  }),
  methods: {
    refreshAttachments() {
      if (this.$refs.attachmentsTableRef) {
        this.loading_files = true;
        this.$refs.attachmentsTableRef.refreshAttachments().then(() => {
          this.loading_files = false;
        });
      }
    },

    handleClickGenerateForms() {
      this.$refs.form_filler.init();
    },
    async updateFileLocked(item, is_locked) {
      const response = await this.$http.post(
        `attachments/${item.id}/update_lock`,
        {
          is_locked,
        }
      );

      this.files = this.files.map((file) => {
        if (file.id == response.data.id) {
          return {
            ...file,
            is_locked: response.data.is_locked,
          };
        }

        return file;
      });
    },
    handleCategorizeFiles() {
      this.$refs.attachmentsTableRef.handleCategorizeFiles(this.selectedFiles);
    },
    async handleDestroyMultipleFiles() {
      this.$store.dispatch("confirm_dialog/confirm", {
        title:
          this.__("excluir", "documents") +
          ` ${this.selectedFiles.length} ` +
          this.__("anexos", "documents"),
        description: this.__(
          "a ação irá remover da lead todos os arquivos selecionados, não será possível desfazer a ação",
          "documents"
        ),
        positive_action: () => this.destroyMultipleFiles(),
      });
    },
    async destroyMultipleFiles() {
      const files = this.selectedFiles.map((file) => file.id);

      this.deleting = true;
      try {
        const response = await multipleDestroy(files);
        const deletedFiles = response.deleted;
        const fails = response.errors;

        this.files = this.files.filter(
          (file) => !deletedFiles.includes(file.id)
        );
        this.selectedFiles = [];
        this.$store.commit(
          "alert",
          `${deletedFiles.length}` +
            this.__("arquivos excluídos", "documents") +
            `, ${fails.length}` +
            this.__("erros", "documents")
        );
        this.refreshAttachments();
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.deleting = false;
      }
    },
    handleClickCategory(file) {
      this.$refs.categoryDialog.init(file);
    },
    deleteFile(file_deleted) {
      this.files = this.files.filter((file) => {
        return file.id !== file_deleted;
      });
      this.file_preview = false;
    },
    updateFile(file_changed) {
      this.files = this.files.map((file_for_change) => {
        return file_for_change.id === file_changed.id
          ? { ...file_changed }
          : file_for_change;
      });
    },
    openFilesDialog() {
      this.$refs.file.click();
    },
    handleDrop(data, event) {
      event.preventDefault();
      this.realTimeOver = false;
      if (this.uploading) {
        this.$store.commit(
          "alert",
          +this.__(
            "existem uploads na fila, aguarde a finalização",
            "documents"
          )
        );
        return;
      }

      const files = event.dataTransfer.files;

      this.uploadFiles(files);
    },
    async uploadFiles(files) {
      this.uploading = true;
      this.uploadCount = files.length;
      try {
        for (let file of files) {
          await this.delay(1000);
          const response = await this.addFile(file);
          this.files.push({ ...response });
          this.uploadCount -= 1;
        }
        this.$store.commit(
          "alert",
          `${files.length} ` + this.__("anexos carregados")
        );
      } catch (e) {
        if (e.response.status === 422) {
          this.$store.commit("sendMessage", {
            text:
              e.response.data.errors.attachment[0] ||
              this.__("não foi possível fazer upload do anexo"),
            color: "red",
          });

          return;
        }

        this.$store.commit("sendMessage", {
          text: e.response.data.message,
          color: "red",
        });
      } finally {
        this.uploading = false;
      }

      this.$refs.file.value = "";
    },
    async handleUploadFiles($event) {
      await this.uploadFiles($event.target.files);

      this.$refs.file.value = "";
    },
    async addFile(file, category_id = null, description = "") {
      let data = new FormData();
      data.append("attachment", file);
      if (category_id !== null) data.append("category_id", category_id);
      data.append("description", description);

      await store(this.$route.params["lead_number"], data);

      this.$nextTick(() => {
        if (this.$refs.attachmentsTableRef) {
          return this.$refs.attachmentsTableRef.refreshAttachments();
        }
      });
    },
    delay(delay) {
      return new Promise((resolve) => setTimeout(resolve, delay));
    },
    async downloadFile(file) {
      window.open(file.public_url);
    },

    updateAttachments(attachments) {
      this.attachments = attachments;
    },
    getFilesInFolder(folder_id) {
      return this.files.filter((file) => {
        return file.category_id == folder_id;
      });
    },
    async handleChangeInsurerVisibilityMultipleFiles(visibility) {
      if (this.cantSendInsurerMessages.length > 0) {
        this.sendToErrorDialog = true;
        this.sendToErrorMessages = this.cantSendInsurerMessages;
        return;
      }

      this.$store.dispatch("confirm_dialog/confirm", {
        title: `${this.__("enviar", "documents")} ${
          this.selectedFiles.length
        } ${this.__("anexos", "documents")}`,
        description: this.__(
          "a ação irá dar visibilidade de todos os arquivos selecionados para a companhia",
          "documents"
        ),
        positive_action: async () => {
          this.updating_visibility_insurer = true;
          this.changeVisibilityMultipleFiles("insurer", visibility);
          this.updating_visibility_insurer = false;
        },
      });
    },
    async handleChangeUnityVisibilityMultipleFiles(visibility) {
      if (this.cantSendMessages.length > 0) {
        this.sendToErrorDialog = true;
        this.sendToErrorMessages = this.cantSendMessages;
        return;
      }

      this.$store.dispatch("confirm_dialog/confirm", {
        title: `${this.__("alterar", "documents")} ${
          this.selectedFiles.length
        } ${this.__("anexos", "documents")}`,
        description: this.__(
          "a ação irá dar visibilidade de todos os arquivos selecionados para a unidade",
          "documents"
        ),
        positive_action: async () => {
          this.updating_visibility_unity = true;
          this.changeVisibilityMultipleFiles("unity", visibility);
          this.updating_visibility_unity = false;
        },
      });
    },
    async changeVisibilityMultipleFiles(entity, visibility = true) {
      const files = this.selectedFiles.map((file) => file.id);

      try {
        const response = await changeManyAttachmentsVisibility(
          files,
          entity,
          visibility
        );
        const updatedFiles = response;

        this.files = this.files.filter(
          (file) => !updatedFiles.includes(file.id)
        );
        this.$refs.attachmentsTableRef.refreshAttachments();
        this.selectedFiles = [];
        this.$store.commit(
          "alert",
          `${updatedFiles.length} ${this.__("anexos afetados", "documents")}`
        );
      } catch (error) {
        this.$store.commit("error", error);
      }
    },
    handleOpenPropertyRegistryDocument(attachment) {
      console.log("Property Registry attachment:", attachment);
      console.log("public_url:", attachment.public_url);
      console.log("url:", attachment.url);

      this.file = { ...attachment };
      this.file_preview = true;
    },
  },

  async created() {
    this.propertyRegistryEnabled = await this.checkFeature("property-registry");
  },

  computed: {
    cantSendMessages() {
      const messages = [];

      if (this.uncategorized_selected_files.length > 0) {
        messages.push({
          text: this.__(
            "não é possível enviar pois há arquivos selecionados sem categorização:",
            "documents"
          ),
          files: this.uncategorized_selected_files,
        });
      }

      return messages;
    },

    cantSendInsurerMessages() {
      const messages = this.cantSendMessages;

      if (this.insurer_locked_selected_files.length > 0) {
        messages.push({
          text: this.__(
            "não é possível enviar pois há arquivos selecionados com bloqueio de envio:",
            "documents"
          ),
          files: this.insurer_locked_selected_files,
        });
      }

      return messages;
    },
    group() {
      return this.groupTab === 0 ? false : true;
    },
    cantSendToInsurer() {
      return (
        this.insurer_locked_selected_files.length > 0 ||
        this.uncategorized_selected_files.length > 0
      );
    },
    cantSendToUnity() {
      return this.uncategorized_selected_files.length > 0;
    },
    insurer_locked_selected_files() {
      return this.selectedFiles.filter((file) => file.is_locked);
    },
    uncategorized_selected_files() {
      return this.selectedFiles.filter((file) => file.category_id == null);
    },
    lead() {
      return this.$store.getters.getLead;
    },
    insurer_portal_companhia() {
      return this.lead.insurer.portal_companhia;
    },
  },
  watch: {
    // Elimina ruídos no drop
    realTimeOver: _.debounce(function (value) {
      this.over = value;
    }, 100),
  },
};
</script>
